import React, { useId, cloneElement, isValidElement } from 'react';
import { InfoTooltip } from './InfoTooltip';
interface FormFieldProps {
  label: string;
  required?: boolean;
  tooltip?: string;
  error?: string;
  description?: string;
  /** Pass child as a render prop receiving { id, describedBy, invalid } so the input wires up ARIA correctly */
  children: React.ReactNode | ((args: {
    id: string;
    describedBy?: string;
    invalid: boolean;
  }) => React.ReactNode);
}
export function FormField({
  label,
  required = false,
  tooltip,
  error,
  description,
  children
}: FormFieldProps) {
  const id = useId();
  const descId = description ? `${id}-desc` : undefined;
  const errId = error ? `${id}-err` : undefined;
  const describedBy = [descId, errId].filter(Boolean).join(' ') || undefined;
  const invalid = !!error;
  return <div className="mb-4" data-id="element-13516">
      <div className="flex items-center mb-1" data-id="element-13517">
        <label htmlFor={id} className="block text-sm font-medium text-gray-700" data-id="element-13518">
          {label}
          {required && <>
              <span aria-hidden="true" className="text-red-600 ml-0.5" data-id="element-13519">
                *
              </span>
              <span className="sr-only" data-id="element-13520"> (required)</span>
            </>}
        </label>
        {tooltip && <InfoTooltip content={tooltip} data-id="element-13521" />}
      </div>

      {description && <p id={descId} className="text-xs text-gray-600 mb-1.5" data-id="element-13522">
          {description}
        </p>}

      {typeof children === 'function' ? children({
      id,
      describedBy,
      invalid
    }) : isValidElement(children) ? cloneElement(children as React.ReactElement<any>, {
      id: (children as React.ReactElement<any>).props.id || id,
      'aria-describedby': describedBy || (children as React.ReactElement<any>).props['aria-describedby'],
      'aria-invalid': invalid || (children as React.ReactElement<any>).props['aria-invalid'],
      'aria-required': required || (children as React.ReactElement<any>).props['aria-required']
    }) : children}

      {error && <p id={errId} role="alert" className="mt-1 text-xs text-red-700" data-id="element-13523">
          {error}
        </p>}
    </div>;
}